import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import "slick-carousel";
import Blazy from "blazy";
import helpers from "../utils/helpers";
import templateContacts from "../partials/template-contacts";

window.recaptchaOnloadCallback = function () {
  window.subRecaptchaKey = grecaptcha.render("subscribe_recaptcha", {
    sitekey: recaptcha_key,
    size: "invisible",
    badge: "inline",
    callback: common.challange,
  });

  if ($("#recaptcha_element").length) {
    window.contactRecaptchaKey = grecaptcha.render("recaptcha_element", {
      sitekey: recaptcha_key,
      size: "invisible",
      badge: "inline",
      callback: templateContacts.challange,
    });
  }
};

const common = {
  form: null,
  bLazy: null,
  dotdotdot: null,

  init: function () {
    common.lazyload();
    common.triggerSearch();
    common.events();
    common.scroll.init();
    common.iframes_notice();

    if ($(".gallery").length) {
      $("body").append(
        '<div id="lookbook-gallery" class="pswp" tabindex="-1" role="dialog" aria-hidden="true"><div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"><div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp-hotspots"></div><div class="desc-wrap"><div class="close-wrap"><a href="#" class="desc-close"><i class="fa fa-chevron-right"></i></a></div><div class="pin-desc" data-id="0"><h2>Title</h2><h4>Subtitle</h4><div class="entry-content"></div></div></div><div class="pswp__ui pswp__ui--hidden"><div class="pswp__top-bar"><div class="pswp-zoom-slider"><div id="range"></div></div><div class="pswp__counter"></div><div class="pswp-gallery-title"></div><button class="pswp__button pswp__button--close" title="Close (Esc)"></button><a href="#" class="image-download-btn" style="display:none" target="_blank"><i class="fa fa-cloud-download"></i></a><button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button><button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button><div class="pswp__preloader"><div class="pswp__preloader__icn"><div class="pswp__preloader__cut"><div class="pswp__preloader__donut"></div></div></div></div></div><button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button><button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button><div class="pswp__caption"><div class="pswp__caption__center"></div></div></div></div></div>'
      );
      common.gallery.init();
    }

    var subscribeForm = $("#subscribe-form");
    if (subscribeForm.length) {
      let script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js?onload=recaptchaOnloadCallback&render=explicit";
      script.async = true;
      script.defer = true;
      script.setAttribute('data-cookieconsent', 'ignore')
      document.head.appendChild(script);
    }
    subscribeForm.children("form").on("submit", function (e) {
      e.preventDefault();
      $(".error", this).removeClass("error");
      if (helpers.validate(subscribeForm)) {
        common.form = "subscribe";
        window.grecaptcha.execute(window.subRecaptchaKey);
      }
    });
  },

  lazyload: function () {
    common.bLazy = new Blazy();
  },

  triggerSearch: function () {
    $('.triggerSearch').on('click', function () {
        if ($(".header").hasClass("header--mobile-open")) {
            $(".header").removeClass("header--mobile-open");
        }

        if ($("html").hasClass("no-scroll")) {
            $("html").removeClass("no-scroll");
        }

        if ($('.search').hasClass('active')) {
            $('.search').removeClass('active');
        } else {
            $('.search').addClass('active');
        }
    });
  },

  iframes_notice: function () {
    const cookie_notice = translations.cookie_notice;
    $("iframe").each(function () {
      if ($(this).data("cookieblock-src")) {
        let is_yt = $(this).data("cookieblock-src").indexOf("youtube") === 12;
        // Skip YouTube videos
        if (is_yt) {
          return;
        }

        // Append cookie notice
        $(this).after(
          `<div class="cookieconsent-optout-statistics"><div class="cookie-notice__content">${common.info_icon}<div class="cookie-notice__text">` +
          cookie_notice +
          "</div></div></div>"
        );
      }
    });
  },

  events: function () {
    var windowScrollTop = $(window).scrollTop();
    // toggle main navigation mobile
    $(".js-toggle-mobile-menu").click(function (e) {
      e.preventDefault();
      $(".header").toggleClass(
        "header--was-scrolled",
        $(".header").hasClass("header--scrolled")
      );
      if ($('.search').hasClass('active')) {
        $('.search').toggleClass('active');
      };

      if (!$(".header").hasClass("header--mobile-open"))
        windowScrollTop = $(window).scrollTop();
      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
      $("html, body").scrollTop(windowScrollTop);
    });

    $(".menu-item-has-children").click(function (event) {
      if (
        $(event.target).hasClass("menu-item-has-children") &&
        $(window).width() < 993
      )
        $(".sub-menu", this).slideToggle(300);
    });

    if ($(".entry-content a img").length) {
      $(".entry-content a").click(function (e) {
        if ($(this).children("img").length) {
          // e.preventDefault();
          var img = new Image();
          img.onload = function () {
            var data = [
              {
                src: this.src,
                w: this.width,
                h: this.height,
              },
            ];
            PhotoSwipe.init(PhotoSwipe, UI, data);
          };
          img.src = $(this).attr("href");
        }
      });
    }
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });
  },

  gallery: {
    init: function () {
      $(".gallery").each(function () {
        const e = $(this);
        const items = [];

        $(".gallery__item", e).each(function () {
          const img = $("img", this);
          items.push({
            src: img.attr("src"),
            w: img.attr("width"),
            h: img.attr("height"),
          });
        });

        $(".gallery__slider", e).on(
          "beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            $(".gallery__status__current", e).text(nextSlide + 1);
          }
        );

        $(".gallery__slider", e)
          .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            adaptiveHeight: true,
            infinite: true,
          })
          .append(
            '<div class="gallery__expand"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">...</svg></div><div class="gallery__status"><span class="gallery__status__current">1</span> / ' +
            items.length +
            "</div>"
          );

        $(".gallery__item", e).click(function () {
          const index = parseInt($(this).data("item"));
          const pswpElement = document.querySelectorAll(".pswp")[0];
          const options = {
            index: index, // start at clicked slide
          };

          const gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
          );
          gallery.init();
        });

        $(".gallery__expand", e).click(function () {
          $(".gallery__item.slick-current", e).click();
        });
      });
    },
  },

  scroll: {
    sticky: false,
    topbar: false,
    last: 0,

    init: function () {
      common.scroll.do();
      $(window).scroll(function () {
        common.scroll.do();
      });
    },

    do: function () {
      var st = $(window).scrollTop();

      if (st > 110 && !common.scroll.sticky) {
        common.scroll.sticky = true;
        $(".header").addClass("header--scrolled");
      } else if (st < 110 && common.scroll.sticky) {
        common.scroll.sticky = false;
        $(".header").removeClass("header--scrolled");
      }
      common.scroll.last = st;
    },
  },

  challange: function (token) {
    if (token) {
      common.subscribe(token);
    }
    window.grecaptcha.reset(window.subRecaptchaKey);
  },

  subscribe: function (token) {
    var subscribeForm = $("#subscribe-form");
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_subscribe",
        "subscribe-email": subscribeForm.find('input[name="email"]').val(),
        "subscribe-nonce": subscribeForm.find("#subscribe-nonce").val(),
        "subscribe-honey": subscribeForm.find("#subscribe-honey").val(),
        "privacy": subscribeForm.find("#subsc_privacy").is(':checked'),
        "subscribe-token": token,
      },
      beforeSend: function () {
        subscribeForm.find("button").addClass("loading");
        subscribeForm.find(".form__status").addClass("hidden");
        subscribeForm.addClass("loading");
      },
    }).done(function (response) {
      subscribeForm.find("button").removeClass("loading");
      subscribeForm.removeClass("loading");
      if (response.success) {
        subscribeForm.find(".errors-wrap").remove();
        subscribeForm
          .find(".form__status")
          .removeClass("error")
          .text(response.data.message)
          .removeClass("hidden");
        subscribeForm.find("form")[0].reset();
        window.grecaptcha.reset(window.subRecaptchaKey);
        subscribeForm.find("input, textarea").blur();
      } else {
        subscribeForm
          .find(".form__status")
          .addClass("error")
          .text(response.data.message)
          .removeClass("hidden");
      }
    });
  },

  info_icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.42857C5.26613 1.42857 1.42857 5.26613 1.42857 10C1.42857 14.7339 5.26613 18.5714 10 18.5714C14.7339 18.5714 18.5714 14.7339 18.5714 10C18.5714 5.26613 14.7339 1.42857 10 1.42857Z" fill="#1A1A1A"></path>
			<path d="M10.2035 6.22443C10.7107 6.22443 11.1219 5.81326 11.1219 5.30606C11.1219 4.79886 10.7107 4.3877 10.2035 4.3877C9.69632 4.3877 9.28516 4.79886 9.28516 5.30606C9.28516 5.81326 9.69632 6.22443 10.2035 6.22443Z" fill="#1A1A1A"></path>
			<path d="M12.4332 13.5455C13.3261 13.5887 13.3261 14.9287 12.4332 14.9719L8.39202 14.973C7.99753 14.973 7.67773 14.6532 7.67773 14.2587C7.67773 13.8774 7.97657 13.5658 8.35283 13.5455L9.69447 13.5443V8.8L8.7763 8.80015C8.39496 8.80015 8.08342 8.50132 8.06307 8.12506L8.06202 8.08587C8.06202 7.70453 8.36085 7.39298 8.73711 7.37264L8.7763 7.37158H10.409C10.7903 7.37158 11.1018 7.67041 11.1222 8.04668L11.1232 8.08587L11.123 13.5443L12.4332 13.5455Z" fill="#1A1A1A"></path>
		</svg>`,
};

export default common;
